import {actions, ActionType} from './action';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../../common/util/redux';
import {ITimeTableDay} from '../../timeTable/type';
import {INITIAL_SECOND_TABS} from '../common';
import {HomeTabPage, IEventPopup, INoticePopup, ISecondTabs} from '../type';

export interface IStateHome {
  isInitialized: boolean;
  tabPage: HomeTabPage;
  secondTabs: ISecondTabs;
  secondTabClickCount: number;
  eventPopupList?: IEventPopup[];
  noticePopup?: INoticePopup;
  todayWeekday?: ITimeTableDay;
  isInitialFetchedPages: {[key in HomeTabPage]: boolean};
  isPreserveQueryParams?: boolean;
}

const INITIAL_STATE: IStateHome = {
  isInitialized: false,
  tabPage: HomeTabPage.Main,
  secondTabs: INITIAL_SECOND_TABS,
  secondTabClickCount: 0,
  eventPopupList: undefined,
  isInitialFetchedPages: {
    [HomeTabPage.Main]: false,
    [HomeTabPage.TimeTable]: false,
    [HomeTabPage.MyPage]: false,
  },
};

export default createReducer<IStateHome, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    [ActionType.ChangeSecondTabSelected]: (state, action) => {
      const {tabPage, selected, isTabClick} = action.payload;
      const secondTabs = state.secondTabs[tabPage];
      if (selected && secondTabs?.tabList.find(({key}) => key === selected)) {
        secondTabs.selected = selected;
      }
      state.tabPage = tabPage;
      isTabClick && (state.secondTabClickCount += 1);
    },
    [ActionType.SetMessages]: (state, action) => {
      const {eventPopupList, noticePopup} = action.payload;
      state.eventPopupList = eventPopupList;
      state.noticePopup = noticePopup;
    },
    [ActionType.InitializeHome]: (state, action) => {
      const {
        initialTabPage,
        initialSecondTab,
        initialMainSecondTab,
        todayWeekday,
      } = action.payload;
      const secondTabs = state.secondTabs[initialTabPage];
      state.secondTabs[HomeTabPage.TimeTable].selected = todayWeekday;
      state.todayWeekday = todayWeekday;
      if (secondTabs) {
        state.tabPage = initialTabPage;
        initialSecondTab &&
          secondTabs.tabList.find(item => item.key === initialSecondTab) &&
          (secondTabs.selected = initialSecondTab);
      }
      if (initialTabPage === HomeTabPage.Main) {
        state.isInitialFetchedPages[HomeTabPage.Main] = true;
      }
      state.secondTabs[HomeTabPage.Main].selected = initialMainSecondTab;
      state.isInitialized = true;
    },
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
    }),
  }
);
